import {
  GET_TAX_DOCUMENT_LIST,
  GET_TAX_DOCUMENT_LIST_SUCCESS,
  GET_TAX_DOCUMENT_LIST_FAILURE,
  GET_TAX_DOCUMENT,
  GET_TAX_DOCUMENT_SUCCESS,
  GET_TAX_DOCUMENT_FAILURE,
} from './constant';
// Get Tax Document List API actions.
export const getTaxDocumentList = (token) => ({
  type: GET_TAX_DOCUMENT_LIST,
  payload: { token },
});
export const getTaxDocumentListSuccess = (data) => ({
  type: GET_TAX_DOCUMENT_LIST_SUCCESS,
  payload: { data },
});
export const getTaxDocumentListFailure = (error) => ({
  type: GET_TAX_DOCUMENT_LIST_FAILURE,
  payload: { error },
});

// Get Tax Document API actions will go here.
export const getTaxDocument = (token, formId) => ({
  type: GET_TAX_DOCUMENT,
  payload: { token, formId },
});

export const getTaxDocumentSuccess = (data) => ({
  type: GET_TAX_DOCUMENT_SUCCESS,
  payload: { data },
});

export const getTaxDocumentFailure = (error) => ({
  type: GET_TAX_DOCUMENT_FAILURE,
  payload: { error },
});
